
export class ImpressionEtiquetteData {
    id: Number;
    label: String;
    type: String;
}